define([
	"dijit/form/Button",
	"./_Plugin",
	"./PluginFactory"
], function(Button, _Plugin, PluginFactory) {

	return PluginFactory.declare([Button, _Plugin], {
		iconClass: "dijitNoIcon",
		label: "Edit",
		pluginName: "edit",
		title: "Edit",
		showLabel: true,

		canShowPlugin: function() {
			// summary: show edit button only on normal mode and if user has access to edit the revision
			return this.editor.view.canEditCanvas() && !this.editor.editMode;
		},

		/**
		 * Start edit mode in canvas; use throttled on click to prevent double-click errors
		 */
		onClickThrottled: function() {
			this.getView().edit();
		},

		/**
		 * This Edit plugin being enabled by ImageReplaceIndicator plugin, 
		 * we make it disabled here to prevent access to editing before we resolve indicator state.
		 */
		enablePlugin: function() {
			this._setDisabled(this, true);
			return false;
		}
	});
});